import { render, staticRenderFns } from "./TourMultipleSummaryCard.vue?vue&type=template&id=74ebde54"
import script from "./TourMultipleSummaryCard.vue?vue&type=script&lang=js"
export * from "./TourMultipleSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports